import React from 'react';
import { ShippingStatusUploadContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { portalService } from 'apiServices';
import { toast } from 'react-toastify';
import { Buttons, Displays, Inputs } from 'components';
import {
  parseShippingStatusFile,
  validateParsedResult,
  downloadErrorReport,
} from 'utils/functions/shippingUpload';

const PREVIEW_LIMIT = 20;

class ShippingStatusUploadContainer extends React.Component {
  state = { step: 1, fileCurrent: null, parsed: null, result: null };

  handleChangeFile = (files) => {
    this.setState({
      fileCurrent: files,
      parsed: null,
      result: null,
      step: 1,
    });
  };

  // สเต็ป 2 - อ่านและตรวจไฟล์ในเครื่อง ยังไม่ยิง API
  handleCheckFile = async () => {
    const { fileCurrent } = this.state;
    if (!fileCurrent || fileCurrent.length === 0) {
      toast.error('กรุณาเลือกไฟล์');
      return;
    }
    this.setState({ isLoadingBg: true });
    const parsed = await parseShippingStatusFile(
      fileCurrent[fileCurrent.length - 1]
    );
    this.setState({ isLoadingBg: false });

    if (parsed.fileError) {
      toast.error(parsed.fileError);
      return;
    }
    const validateError = validateParsedResult(parsed);
    if (validateError) {
      toast.error(validateError);
      return;
    }
    this.setState({ parsed: parsed, step: 2 });
  };

  // สเต็ป 3 - ยืนยันแล้วส่งจริง
  handleSubmit = async () => {
    const { parsed, fileCurrent } = this.state;
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    this.setState({ isLoadingBg: true });

    const file = fileCurrent[fileCurrent.length - 1];
    let res = await portalService.POST_REWARD_HISTORY_SHIPPING_STATUS_BULK({
      file_name: file && file.name,
      items: parsed.items.map((e) => ({
        row_no: e.row_no,
        id: e.id,
        login_id: e.login_id,
        reward_code: e.reward_code,
        from_status: e.from_status,
        shipping_status: e.shipping_status,
        reason: e.reason,
      })),
    });

    this.isSubmitting = false;
    this.setState({ isLoadingBg: false });

    if (res && res.status === 200) {
      const data = res.data || {};
      this.setState({ step: 3, result: { ok: true, ...data } });
      toast.success(res.Message || 'อัปเดตสถานะสำเร็จ');
      // รีเฟรชตารางด้านหลังเสมอ แต่ไม่ปิดโมดัล ให้ผู้ใช้อ่านผลจบก่อน
      this.props.onUpdated && this.props.onUpdated();
    } else {
      const body = (res && res.data) || {};
      const message =
        (body.error && body.error.message) || 'อัปเดตไม่สำเร็จ';
      this.setState({
        step: 3,
        result: { ok: false, message: message, ...(body.data || {}) },
      });
      toast.error(message);
    }
  };

  handleDownloadErrors = () => {
    const { parsed, result } = this.state;
    const errors =
      (result && result.errors) || (parsed && parsed.errors) || [];
    if (errors.length === 0) return;
    downloadErrorReport(errors);
  };

  handleBack = () => {
    this.setState({ step: 1, parsed: null, result: null });
  };

  renderStep1 = () => {
    const { fileCurrent } = this.state;
    return (
      <>
        <div className="help_block">
          <div className="help_title">วิธีใช้</div>
          <ol>
            <li>
              กด Export ในหน้านี้เพื่อดาวน์โหลดไฟล์ตั้งต้น
              (ไฟล์มี sheet "วิธีใช้" อธิบายไว้ด้วย)
            </li>
            <li>
              กรอกเฉพาะคอลัมน์ <b>"สถานะใหม่"</b> เป็นภาษาไทย
              แถวที่ไม่ต้องการเปลี่ยนให้เว้นว่างไว้
            </li>
            <li>
              ห้ามแก้คอลัมน์ <b>"Ref ID"</b> และ <b>"สถานะการจัดส่ง"</b>{' '}
              (แก้คอลัมน์อื่นจะไม่มีผลกับระบบ)
            </li>
            <li>บันทึกเป็น .xlsx แล้วอัปโหลดกลับที่นี่</li>
          </ol>
          <div className="help_note">
            ถ้ามีแถวใดกรอกผิด ระบบจะไม่บันทึกทั้งไฟล์
            แก้แล้วอัปโหลดใหม่ได้ทันที · อัปโหลดไฟล์เดิมซ้ำได้เสมอ
            ระบบจะข้ามรายการที่อัปเดตไปแล้ว
          </div>
        </div>
        <div className="upload_row">
          <Inputs.UploadImage
            theme_upload_image
            acceptType="excel"
            value={fileCurrent}
            onChange={this.handleChangeFile}
          />
        </div>
        <div className="action_row">
          <div className="btn_item">
            <Buttons.BgStandard
              theme_gray
              label="ปิด"
              onClick={this.props.onCancel}
            />
          </div>
          <div className="btn_item">
            <Buttons.BgStandard
              label="ตรวจสอบไฟล์"
              onClick={this.handleCheckFile}
            />
          </div>
        </div>
      </>
    );
  };

  renderStep2 = () => {
    const { parsed } = this.state;
    const hasError = parsed.errors.length > 0;
    return (
      <>
        <div className="summary_row">
          <div className="summary_item">
            <div className="summary_num">{parsed.items.length}</div>
            <div className="summary_label">รายการที่จะเปลี่ยน</div>
          </div>
          <div className="summary_item">
            <div className="summary_num">{parsed.skipped.length}</div>
            <div className="summary_label">ข้าม</div>
          </div>
          <div className={`summary_item ${hasError ? 'is_error' : ''}`}>
            <div className="summary_num">{parsed.errors.length}</div>
            <div className="summary_label">ข้อผิดพลาด</div>
          </div>
        </div>

        {hasError ? (
          <>
            <div className="section_title error">
              พบข้อผิดพลาด กรุณาแก้ไขไฟล์แล้วอัปโหลดใหม่
            </div>
            <div className="table_wrap">
              <table>
                <thead>
                  <tr>
                    <th className="w60">แถวที่</th>
                    <th>Login ID</th>
                    <th>สาเหตุ</th>
                  </tr>
                </thead>
                <tbody>
                  {parsed.errors.map((e, i) => (
                    <tr key={i}>
                      <td>{e.row_no}</td>
                      <td>{e.login_id || '-'}</td>
                      <td>{e.reason_message}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <>
            <div className="section_title">
              ตรวจสอบรายการก่อนยืนยัน
              {parsed.items.length > PREVIEW_LIMIT &&
                ` (แสดง ${PREVIEW_LIMIT} จาก ${parsed.items.length} รายการ)`}
            </div>
            <div className="table_wrap">
              <table>
                <thead>
                  <tr>
                    <th className="w60">แถวที่</th>
                    <th>Login ID</th>
                    <th>ของรางวัล</th>
                    <th>เดิม</th>
                    <th>ใหม่</th>
                    <th>เหตุผล</th>
                  </tr>
                </thead>
                <tbody>
                  {parsed.items.slice(0, PREVIEW_LIMIT).map((e, i) => (
                    <tr key={i}>
                      <td>{e.row_no}</td>
                      <td>{e.login_id || '-'}</td>
                      <td>{e.reward_name || e.reward_code || '-'}</td>
                      <td>{e.current_status_text || '-'}</td>
                      <td className="highlight">{e.new_status_text}</td>
                      <td>{e.reason || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        <div className="action_row">
          <div className="btn_item">
            <Buttons.BgStandard
              theme_gray
              label="เลือกไฟล์ใหม่"
              onClick={this.handleBack}
            />
          </div>
          {hasError && (
            <div className="btn_item wide">
              <Buttons.BgStandard
                theme_gray
                label="ดาวน์โหลดรายการที่ผิด"
                onClick={this.handleDownloadErrors}
              />
            </div>
          )}
          <div className="btn_item">
            <Buttons.BgStandard
              label={`ยืนยัน (${parsed.items.length})`}
              onClick={this.handleSubmit}
              disabled={hasError || parsed.items.length === 0}
            />
          </div>
        </div>
      </>
    );
  };

  renderStep3 = () => {
    const { result } = this.state;
    if (result.ok) {
      return (
        <>
          <div className="section_title success">
            อัปเดตสำเร็จ {result.success_count} รายการ
            {result.skip_count > 0 && ` · ข้าม ${result.skip_count} รายการ`}
          </div>
          {result.skipped && result.skipped.length > 0 && (
            <div className="table_wrap">
              <table>
                <thead>
                  <tr>
                    <th className="w60">แถวที่</th>
                    <th>หมายเหตุ</th>
                  </tr>
                </thead>
                <tbody>
                  {result.skipped.map((e, i) => (
                    <tr key={i}>
                      <td>{e.row_no}</td>
                      <td>{e.note}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div className="action_row">
            <div className="btn_item">
              <Buttons.BgStandard
                label="เสร็จสิ้น"
                onClick={this.props.onCancel}
              />
            </div>
          </div>
        </>
      );
    }
    return (
      <>
        <div className="section_title error">{result.message}</div>
        {result.errors && result.errors.length > 0 && (
          <div className="table_wrap">
            <table>
              <thead>
                <tr>
                  <th className="w60">แถวที่</th>
                  <th>Login ID</th>
                  <th>สาเหตุ</th>
                </tr>
              </thead>
              <tbody>
                {result.errors.map((e, i) => (
                  <tr key={i}>
                    <td>{e.row_no}</td>
                    <td>{e.login_id || '-'}</td>
                    <td>{e.reason_message}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="retry_note">
          ถ้าไม่แน่ใจว่าบันทึกสำเร็จหรือไม่ อัปโหลดไฟล์เดิมซ้ำได้ทันที
          ระบบจะข้ามรายการที่อัปเดตไปแล้ว
        </div>
        <div className="action_row">
          <div className="btn_item">
            <Buttons.BgStandard
              theme_gray
              label="เลือกไฟล์ใหม่"
              onClick={this.handleBack}
            />
          </div>
          {result.errors && result.errors.length > 0 && (
            <div className="btn_item wide">
              <Buttons.BgStandard
                label="ดาวน์โหลดรายการที่ผิด"
                onClick={this.handleDownloadErrors}
              />
            </div>
          )}
        </div>
      </>
    );
  };

  render() {
    const { step, isLoadingBg } = this.state;
    return (
      <ShippingStatusUploadContainerStyled>
        <Displays.BGLoading visible={isLoadingBg} />
        <div className="modal_title">อัปเดตสถานะการจัดส่งจากไฟล์</div>
        <div className="step_bar">
          {['เลือกไฟล์', 'ตรวจสอบ', 'ผลลัพธ์'].map((label, i) => (
            <div
              key={label}
              className={`step_item ${step === i + 1 ? 'active' : ''} ${
                step > i + 1 ? 'done' : ''
              }`}
            >
              {i + 1}. {label}
            </div>
          ))}
        </div>
        {step === 1 && this.renderStep1()}
        {step === 2 && this.renderStep2()}
        {step === 3 && this.renderStep3()}
      </ShippingStatusUploadContainerStyled>
    );
  }
}

export default withRouter(ShippingStatusUploadContainer);
